module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vsens25-d82d324d2feb608ae8eeb736e78e69f5.jpg";